import { ActivatedRoute } from '@angular/router';
import { Component, OnInit } from '@angular/core';
import { PortfolioPath, PreferencesPath, InvestmentPath } from '../navigation/routes';
import { Keys, StorageService } from '../service/storage.service';
import { LenderDetailsService } from '../service/lender-details.service';

@Component({
    selector: 'app-investormenu',
    templateUrl: './investormenu.component.html',
    styleUrls: ['./investormenu.component.css']
})
export class InvestormenuComponent implements OnInit {
    public readonly passbookLink = ['/lenderpassbook'];
    public readonly consentLink = ['/lenderconsent'];
    public readonly walletLink = ['/investorwallet'];
    public readonly preferencesLink = ['/preferences'];
    public dashboardLink = ['/investordashboard'];
    public investmentLink: any;
    provisionalLink: any;
    dashboardClass: string;
    passbookClass: string;
    walletClass: string;
    consentClass: string;
    referralsClass: string;
    provisionalClass: string;
    preferencesClass: string;
    investmentClass: string;
    isFinx: boolean;
    private readonly route: ActivatedRoute;
    private readonly storageService: StorageService;
    private readonly lenderDetailsService: LenderDetailsService;

    constructor(route: ActivatedRoute, storageService: StorageService, lenderDetailsService: LenderDetailsService) {
        this.route = route;
        this.storageService = storageService;
        this.lenderDetailsService = lenderDetailsService;
    }

    async ngOnInit() {
        const pathFromRoot = this.getPathFromRoot();
        if (pathFromRoot.startsWith(PreferencesPath)) {
            this.preferencesClass = '-active';
        } else if (pathFromRoot.startsWith(PortfolioPath)) {
            this.dashboardClass = '-active';
        } else if (pathFromRoot.startsWith(InvestmentPath)) {
            this.investmentClass = '-active';
        } else if (this.route.snapshot.url.length > 0) {
            const path = this.route.snapshot.url[0].path;
            if (path === 'lenderpassbook') {
                this.passbookClass = '-active';
            } else if (path === 'referrals') {
                this.referralsClass = '-active';
            } else if (path === 'investorwallet') {
                this.walletClass = '-active';
            } else if (path === 'lenderconsent') {
                this.consentClass = '-active';
            } else if (path === 'interest-certificate') {
                this.provisionalClass = '-active';
            } else if (path === 'lenderinitial' || path === 'loandetail' || path === 'investordashboard') {
                this.dashboardClass = '-active';
            }
        }

        const lenderId = this.storageService.getItem(Keys.LENDER_ID);
        const profileId = this.storageService.getItem(Keys.PROFILE_ID);
        this.isFinx = this.storageService.getItem(Keys.FINX) === "true" && this.storageService.getItem(Keys.IS_LENDER_CREATED_AFTER_RESTRICTED_DATE) === "true";
        const lenderDetails = await this.lenderDetailsService.getLenderWalletAmountAndPhotoUrl(profileId);
        const lender_application_status = lenderDetails.lender_application_status;
        if (['pending', 'ready_for_kyc', 'kyc_in_progress'].includes(lender_application_status)) {
            this.dashboardLink = ['/lenderinitial'];
        } else if (['verified', 'invested'].includes(lender_application_status)) {
            this.provisionalLink = ['/interest-certificate'];
            this.investmentLink = ['/investments'];
        }
    }

    private getPathFromRoot(): string {
        return this.route.pathFromRoot.map(r => r.snapshot.url)
            .reduce((acc, val) => acc.concat(val), [])
            .map(url => url.path)
            .join('/');
    }
}
